import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Avatar,
  Button,
  Card,
  Container,
  CircularProgress,
  Divider,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  makeStyles,
  Paper,
  Snackbar,
  Tab,
  Tabs,
  Typography,
  ListItemSecondaryAction,
  Slide,
  Dialog,
  AppBar,
  Toolbar,
  DialogTitle,
  DialogContent,
  TextField,
  DialogContentText,
  DialogActions,
} from "@material-ui/core";
import { green, grey, orange, purple, red } from "@material-ui/core/colors";
import { Close, Delete, EditOutlined, ExpandMore, FileCopy, GetApp, Person, Phone, RemoveRedEyeOutlined, Schedule } from "@material-ui/icons";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { withFirebase } from "../Firebase";
import { Skeleton } from "@material-ui/lab";
import RefreshmentGroupcard from "./RefreshmentGroupcard";
import { CSVLink } from "react-csv";
import { useHistory } from "react-router-dom";
import Footer from "../Footer";
import * as ROUTES from "../../constants/routes";
import RescuerProfile from "../RescuerProfile";
import ChangeformationGroup from "./ChangeformationGroup";
import UserProfile from "../Profile/UserProfile";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
      {value === index && children}
    </div>
  );
}

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const FormViewPage = ({ formData, backF, firebase }) => {
  const { formConfig, key } = formData;
  const QRCode = require("qrcode.react");
  const { t, i18n } = useTranslation();
  const history = useHistory();

  const [snackOpen, setSnackOpen] = useState(false);
  const [isUserProfileOpen, setIsUserProfileOpen] = useState(false);
  const [userProfileData, setuserProfileData] = useState(null);
  const [registrationSummary, setRegistrationSummary] = useState("");
  const [managerRescuers, setManagerRescuers] = useState([]);
  const [tabIndex, setTabIndex] = useState(formConfig.refreshmentGroups != undefined ? 0 : 1);
  const [usersCount, setUsersCount] = useState({ new: 0, refresh: 0 });
  const [isLoadingCSV, setIsLoadingCSV] = useState(false);
  const [openProfile, setopenProfile] = useState(false);
  const [userID, setUserID] = useState("");
  const [openRemoveDialog, setOpenRemoveDialog] = useState(false);
  const [userToRemove, setUserToRemove] = useState(null);
  const csvLink = useRef();

  const now = new Date();
  const start = moment(formConfig.startDay, "DD/MM/yyyy");
  const end = moment(formConfig.endDay, "DD/MM/yyyy");
  var openState;
  var openColor;

  if (moment(now).isBetween(start, end)) {
    openState = `Registro abierto, se cierra el ${end.format("DD/MM/YYYY")}`;
    openColor = green[600];
  } else if (moment(now).isBefore(start)) {
    openState = `Registro sin comenzar, comienza el ${start.format("DD/MM/YYYY")}`;
    openColor = orange[600];
  } else {
    openState = `Registro cerrado el ${end.format("DD/MM/YYYY")}`;
    openColor = red[600];
  }

  const getUserData = (users, currentProccess) => {
    if (users.length > 0) {
      let currentUser = users.shift();

      firebase.userCompletInfo(currentUser.uid).then((rescuer) => {
        const info = rescuer?.userInfo?.info;
        const report = rescuer?.reports?.tests;
        const systemConf = rescuer?.userInfo?.sgpfc;
        currentProccess.push({
          ...rescuer,
          nombre: info?.name,
          apellido: info?.surname + " " + info?.secondSurname,
          dni: info?.dni,
          idiomaComunicaciones: info?.comunicationsLang,
          comunicaciones: info?.comunicaciones,
          telefono: info?.phone,
          rescatador: systemConf?.notifications,
          eval1: report?.ECS1?.metadata?.evalApproved,
          eval2: report?.ECS2?.metadata?.evalApproved,
          eval3: report?.ECS3?.metadata?.evalApproved,
          output: `${currentUser.fecha},${currentUser.hora},${info?.name},${info?.surname + " " + info?.secondSurname},${info?.comunicaciones},${info?.OS},${
            info?.comunicationsLang
          },${info?.dni},${info?.phone},${currentUser.email},${t(systemConf?.notifications.rescuer)},${t(systemConf?.notifications.userEnabled)},${t(
            report?.ECS1?.metadata?.evalApproved
          )},${t(report?.ECS2?.metadata?.evalApproved)},${t(report?.ECS3?.metadata?.evalApproved)}`,
        });
        getUserData(users, currentProccess);
      });
    } else {
      currentProccess.shift();
      console.table(currentProccess);
      let text =
        "Fecha formación, Hora formación, Nombre, Apellidos, Comunicaciones comerciales,Sistema operativo, Idoma de contacto,DNI, Teléfono,Email,Ha completado la formación online,Tiene en el alert las alertas activas,Evaluación 1, Evaluación 2, Evaluación 3\n";
      currentProccess.forEach((u) => (text += `${u.output}\n`));
      //  console.log(text);
      setRegistrationSummary(text);
      csvLink.current.link.click();
      setIsLoadingCSV(false);
    }
  };

  const downloadData = () => {
    setIsLoadingCSV(true);
    let d = [];
    let date;
    let time;
    let auxName;
    // console.table(formData.formConfig.formationGroups);
    formData?.formConfig?.formationGroups?.forEach((l) => {
      date = moment(l.time).format("LL");
      time = moment(l.time).format("HH:mm");
      l.rescuers?.forEach((r) => {
        auxName = r.name.split(" ");
        let surnamme = auxName.splice(1, auxName.length).reduce((a, b) => a + " " + b, "");
        r.deleted !== true &&
          d.push({
            fecha: date,
            hora: time,
            nombre: auxName[0],
            apellido: surnamme,
            email: r.email,
            uid: r.uid,
          });
      });
    });
    formData?.formConfig?.refreshmentGroups?.forEach((l) => {
      time = moment(l.time).format("HH:mm");
      date = moment(l.time).format("LL");
      l.rescuers?.forEach((r) => {
        d.push({
          fecha: date,
          hora: time,
          nombre: r.name,
          apellido: "",
          email: r.email,
          uid: r.uid,
        });
      });
    });
    getUserData(d, [0]);
  };

  const getRescuerData = (users, data) => {
    if (users?.length > 0) {
      let currentUser = users.shift();
      //console.log(users.length);
      firebase
        .user(currentUser)
        .once("value")
        .then((snap) => {
          //console.log(currentUser);
          const rescuer = snap.val()?.info;
          typeof rescuer === undefined && console.error("no hay datos del usuario: ", currentUser);
          data.push({
            name: rescuer?.name + " " + rescuer?.surname + " " + rescuer?.secondSurname,
            email: rescuer?.email,
            uid: currentUser,
            formId: key,
          });
          getRescuerData(users, data);
        });
    } else {
      setManagerRescuers(data);
    }
  };

  useEffect(() => {
    firebase
      .managerData(firebase.currentUser().uid)
      .child(`programs/${formConfig.programId}/groups/${formConfig.groupId}/rescuers`)
      .once("value")
      .then((snap) => {
        getRescuerData(snap.val(), []);
      });

    let refreshUsers = 0;
    let newUsers = 0;
    formData?.formConfig?.refreshmentGroups?.map((rg) => {
      refreshUsers += !!rg.rescuers?.length ? rg.rescuers?.length : 0;
    });
    formData?.formConfig?.formationGroups?.map((rg) => {
      newUsers += !!rg.rescuers?.length ? rg.rescuers?.filter((k) => k.deleted !== true).length : 0;
    });
    setUsersCount({
      new: newUsers,
      refresh: refreshUsers,
    });
  }, []);

  return (
    <>
      <Container>
        <Grid container spacing={4} justify="center" style={{ marginTop: 32, marginBottom: 128 }}>
          <Grid item xs={12} lg={10} container justify="flex-start">
            <Button variant="outlined" style={{ textTransform: "none" }} onClick={() => backF(null)}>
              Todos los registros
            </Button>
          </Grid>
          <Grid item xs={12} lg={10}>
            <Card variant="outlined" style={{ padding: 16, borderRadius: 16 }}>
              <Grid container spacing={4}>
                <Grid item xs={8}>
                  <Typography variant="h6" color="primary" style={{ fontSize: 22, fontWeight: 800 }}>
                    {typeof formConfig?.name == "object" ? formConfig.name[i18n.language.split("-")[0]] : formConfig?.name}
                    <IconButton style={{ marginLeft: 9 }} size="small" onClick={() => history.push(`${ROUTES.EDIT_METAFORM_EXACT}/${key}`)}>
                      <EditOutlined />
                    </IconButton>
                    <IconButton size="small" onClick={downloadData} disabled={isLoadingCSV}>
                      {isLoadingCSV ? <CircularProgress size={20} /> : <GetApp />}
                    </IconButton>

                    <CSVLink data={registrationSummary} filename={`registros_${moment().format("DD/MM/YYYY")}.csv`} ref={csvLink} target="_blank" />
                  </Typography>
                  <Typography variant="body1" color="textSecondary" style={{ fontSize: 16, paddingTop: 24 }}>
                    Id. formulario: {key}
                  </Typography>

                  <Typography variant="body1" style={{ color: openColor, fontWeight: 600 }}>
                    {openState}
                  </Typography>
                  <Typography>
                    {formConfig.url}
                    <IconButton
                      size="small"
                      style={{ marginLeft: 6, height: 26, width: 26 }}
                      onClick={() => {
                        setSnackOpen(true);
                        try {
                          navigator.clipboard.writeText(formConfig.url);
                        } catch (error) {
                          console.log(error);
                        }
                      }}
                    >
                      <FileCopy style={{ height: 20, width: 20 }} />
                    </IconButton>
                  </Typography>
                </Grid>

                <Grid item xs={4} container justify="flex-end" alignItems="flex-end" direction="column">
                  <QRCode value={formConfig?.url} size={120} />
                </Grid>
                <Grid item xs={12} container spacing={2}>
                  <Grid item xs={6}>
                    <Typography variant="body1">Id. Programa: {formConfig.programId}</Typography>
                  </Grid>
                  <Grid item xs={6} container justify="flex-end">
                    <Typography variant="body1">Id. Grupo: {formConfig.groupId}</Typography>
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <Typography>Tipo de formulario:</Typography>
                    <Typography variant="body1" style={{ fontWeight: 500 }}>
                      {formConfig.type == "free" && "Libre"}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <Typography>Reanibex Alert:</Typography>
                    <Typography variant="body1" style={{ fontWeight: 500 }}>
                      {formConfig.alertEnabled ? "Acceso a Reanibex Alert" : "Sin acceso a Reanibex Alert"}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <Typography>Manager:</Typography>
                    <Typography variant="body1" style={{ fontWeight: 500 }}>
                      {formConfig.managerUid}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Card>
          </Grid>
          <Grid item xs={12} md={10}>
            <Paper style={{ backgroundColor: purple[50] }}>
              <Tabs value={tabIndex} onChange={(e, v) => setTabIndex(v)} indicatorColor="primary" textColor="primary" centered>
                <Tab
                  disabled={formConfig?.refreshmentGroups == undefined}
                  label={
                    <div>
                      <Typography>Cursos de refresco</Typography>
                      <Typography>
                        <b>{usersCount.refresh}</b> inscritos
                      </Typography>
                    </div>
                  }
                />
                <Tab
                  label={
                    <div>
                      <Typography>Cursos nuevos</Typography>
                      <Typography>
                        <b>{usersCount.new}</b> inscritos
                      </Typography>
                    </div>
                  }
                />
              </Tabs>
            </Paper>
            <TabPanel value={tabIndex} index={0}>
              <Grid container spacing={1} style={{ paddingTop: 16 }}>
                {formConfig?.refreshmentGroups?.map((r, i) => (
                  <RefreshmentGroupcard
                    key={i}
                    w={r}
                    r={managerRescuers}
                    index={i}
                    firebase={firebase}
                    formId={key}
                    setProfileOpen={setIsUserProfileOpen}
                    setUserData={setuserProfileData}
                    openProfile={setopenProfile}
                    uidForEmail={setUserID}
                  />
                ))}
              </Grid>
            </TabPanel>
            <TabPanel value={tabIndex} index={1}>
              <Grid container spacing={1} style={{ paddingTop: 16 }}>
                {formConfig.formationGroups.map((g, i) => (
                  <WorkshopCard
                    key={i}
                    w={g}
                    setProfileOpen={setIsUserProfileOpen}
                    editable={moment(formConfig?.endDay, "DD/MM/YYYY").isSameOrAfter()}
                    setUserData={setuserProfileData}
                    index={i}
                    openProfile={setopenProfile}
                    uidForEmail={setUserID}
                    firebase={firebase}
                  />
                ))}
              </Grid>
            </TabPanel>
          </Grid>
        </Grid>
        <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          open={snackOpen}
          autoHideDuration={3000}
          onClose={() => setSnackOpen(false)}
          message="Copiado al portapapeles"
        />

        {moment().isSameOrBefore(moment(formConfig?.endDay, "DD/MM/YYYY"), "day") && (
          <ChangeformationGroup open={isUserProfileOpen} formId={key} userData={userProfileData} formData={formConfig} setClose={setIsUserProfileOpen} firebase={firebase} />
        )}
      </Container>
      <Dialog
        fullScreen
        open={openProfile}
        onClose={() => {
          setopenProfile(false);
        }}
        TransitionComponent={Transition}
      >
        <AppBar>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={() => {
                setopenProfile(false);
              }}
              aria-label="close"
            >
              <Close />
            </IconButton>
          </Toolbar>
        </AppBar>
        <Grid style={{ marginTop: 46 }}>
          <UserProfile uid={userID} />
        </Grid>
      </Dialog>
      <Footer />
    </>
  );
};

export default withFirebase(FormViewPage);

const WorkshopCard = ({ w, index, setProfileOpen, setUserData, editable, openProfile, uidForEmail, firebase }) => {
  const { t } = useTranslation();

  const [openRemoveDialog, setOpenRemoveDialog] = useState(false);
  const [userToRemove, setUserToRemove] = useState(null);
  const [inputEmail, setInputEmail] = useState("");
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleOpen = (uid) => {
    uidForEmail(uid);
    openProfile(true);
  };
  //
  const hanldeRemove = (uid, email) => {
    setUserToRemove({
      uid: uid,
      email: email,
    });
    setDeleteOpen(true);
  };

  const deleteUser = () => {
    setIsLoading(true);
    firebase.setUsertToremove(userToRemove.uid).then(() => {
      setUserToRemove(null);
      setInputEmail("");
      setIsLoading(false);
      setDeleteOpen(false);
    });
  };

  return (
    <Grid item xs={12}>
      <Card variant="outlined" style={{ padding: 16, borderRadius: 16 }}>
        <Grid item xs={12}>
          <Accordion elevation={0}>
            <AccordionSummary expandIcon={<RemoveRedEyeOutlined />} aria-controls="panel1a-content" id="panel1a-header">
              <Grid item xs={12}>
                <Typography variant="h6" color="textSecondary">
                  {w.text}
                </Typography>
                {(() => {
                  let remaining = w.remaining;
                  let capacity = w.capacity;

                  if (remaining < 0) {
                    capacity += Math.abs(remaining);
                    remaining = 0;
                  }

                  return (
                    <Typography>
                      Plazas restantes {remaining} de {capacity}
                    </Typography>
                  );
                })()}
              </Grid>
            </AccordionSummary>
            <AccordionDetails>
              {
                <List style={{ width: "100%" }}>
                  {w.rescuers ? (
                    w.rescuers.map((r, i) => (
                      <ListItem key={i} alignItems="flex-start" style={{ backgroundColor: r.deleted && red[100], borderRadius: 16, cursor: editable ? "pointer" : "default" }}>
                        <ListItemAvatar>
                          <Avatar style={{ background: r.deleted && red[500] }}>{r?.name?.substring(0, 1)?.toUpperCase()}</Avatar>
                        </ListItemAvatar>
                        <ListItemText
                          primary={`${r.name} ${r.deleted ? "-- usuario Eliminado --" : ""}`}
                          secondary={
                            <React.Fragment>
                              <Typography component="span" variant="body2" color="textPrimary">
                                {r.email}
                              </Typography>
                              {` · ${moment(r.signUp).format("DD/MM/YYYY")}`}
                            </React.Fragment>
                          }
                        />

                        {!r.deleted && (
                          <ListItemSecondaryAction>
                            <IconButton
                              edge="end"
                              size="small"
                              onClick={() => {
                                if (r.deleted !== true) {
                                  setProfileOpen(true);
                                  setUserData({ ...r, workshop: index });
                                }
                              }}
                            >
                              <Schedule />
                            </IconButton>
                            <IconButton
                              edge="end"
                              size="small"
                              onClick={() => {
                                handleOpen(r.uid);
                              }}
                            >
                              <Person />
                            </IconButton>
                            <IconButton edge="end" size="small" onClick={() => hanldeRemove(r.uid, r.email)}>
                              <Delete />
                            </IconButton>
                          </ListItemSecondaryAction>
                        )}

                        <Divider variant="inset" component="li" />
                      </ListItem>
                    ))
                  ) : (
                    <Typography>No hay voluntarios registrados</Typography>
                  )}
                </List>
              }
            </AccordionDetails>
          </Accordion>
        </Grid>
      </Card>
      <Dialog aria-labelledby="simple-dialog-title" open={deleteOpen}>
        <DialogTitle id="simple-dialog-title" style={{ color: red[500] }}>
          ¿Estas completamente seguro?
        </DialogTitle>
        <DialogContent>
          <Grid item xs={12}>
            <DialogContentText>{`Vas a eliminar el usuario "${userToRemove?.email}". Para confirmar laoperación escribe el email del usuario que quieres eliminar. El proceso de eliminar un usuario puede tardar`}</DialogContentText>
            <TextField value={inputEmail} error={inputEmail != userToRemove?.email} onChange={(e) => setInputEmail(e.target.value)} fullWidth variant="outlined" />
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteOpen(false)}>{t("cancelar")}</Button>
          <Button onClick={deleteUser} disabled={inputEmail != userToRemove?.email} variant="outlined" style={{ color: inputEmail == userToRemove?.email && red[500] }}>
            {isLoading && (
              <CircularProgress
                size={24}
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  marginTop: -12,
                  marginLeft: -12,
                }}
              />
            )}
            {t("delete")}
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const grid = 8;

const getItemStyle = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: "none",
  padding: grid * 2,
  margin: `0 0 ${grid}px 0`,
  borderRadius: isDragging ? 16 : 0,
  transition: "border-radius 1s",
  // change background colour if dragging
  background: isDragging && grey[100],
  // styles we need to apply on draggables
  ...draggableStyle,
});

const getListStyle = (isDraggingOver) => ({
  background: isDraggingOver ? "lightblue" : "lightgrey",
});

const WorsShopList = (rescuers, provided, snapshot) => {
  const [items, setitems] = useState(rescuers.rescuers);

  const onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const it = reorder(items, result.source.index, result.destination.index);
    setitems(it);
  };

  return (
    <Grid item xs={12} {...provided.droppableProps} ref={provided.innerRef} style={getListStyle(snapshot.isDraggingOver)}>
      {items.map((item, index) => (
        <Draggable key={item.uid} draggableId={item.uid} index={index}>
          {(provided, snapshot) => (
            <div
              ref={provided.innerRef}
              {...provided.draggableProps}
              {...provided.dragHandleProps}
              className="isDragging"
              style={getItemStyle(snapshot.isDragging, {
                ...provided.draggableProps.style,
                // transition: "border-radius .5s",
              })}
            >
              <ListItem alignItems="flex-start">
                <ListItemAvatar>
                  <Avatar>{item.name.substring(0, 1).toUpperCase()}</Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={item.name}
                  secondary={
                    <React.Fragment>
                      <Typography component="span" variant="body2" color="textPrimary">
                        {item.email}
                      </Typography>
                      {` · ${moment(item.signUp).format("DD/MM/YYYY")}`}
                    </React.Fragment>
                  }
                />
              </ListItem>
            </div>
          )}
        </Draggable>
      ))}
      {provided.placeholder}
    </Grid>
  );
};

const WorkshopContainer = (ws) => {
  const [items, setitems] = useState(ws.ws);

  const onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    console.log("-----------------------------", items);

    const it = reorder(items, result.source.index, result.destination.index);
    setitems(it);
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      {ws.ws.map((w) => (
        <Droppable droppableId="droppable">
          {(provided, snapshot) => (
            <Grid item xs={12} lg={6}>
              <Card variant="outlined" style={{ padding: 16, borderRadius: 16 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography variant="h6" color="textSecondary">
                      {w.text}
                    </Typography>
                    <Typography>
                      Plazas restantes {w.remaining} de {w.capacity}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} style={{ paddingRight: 0, paddingLeft: 0 }}>
                    <Accordion elevation={0}>
                      <AccordionSummary expandIcon={<ExpandMore />} aria-controls="panel1a-content" id="panel1a-header">
                        <Typography>Voluntarios</Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Grid item xs={12} {...provided.droppableProps} ref={provided.innerRef} style={getListStyle(snapshot.isDraggingOver)}>
                          {items.map((item, index) => (
                            <Draggable key={item.uid} draggableId={item.uid} index={index}>
                              {(provided, snapshot) => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                  className="isDragging"
                                  style={getItemStyle(snapshot.isDragging, {
                                    ...provided.draggableProps.style,
                                  })}
                                >
                                  <ListItem alignItems="flex-start">
                                    <ListItemAvatar>
                                      <Avatar>{"Bo".substring(0, 1).toUpperCase()}</Avatar>
                                    </ListItemAvatar>
                                    <ListItemText
                                      primary={item.name}
                                      secondary={
                                        <React.Fragment>
                                          <Typography component="span" variant="body2" color="textPrimary">
                                            {item.email}
                                          </Typography>
                                          {` · ${moment(item.signUp).format("DD/MM/YYYY")}`}
                                        </React.Fragment>
                                      }
                                    />
                                  </ListItem>
                                </div>
                              )}
                            </Draggable>
                          ))}
                          {provided.placeholder}
                        </Grid>
                      </AccordionDetails>
                    </Accordion>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          )}
        </Droppable>
      ))}
    </DragDropContext>
  );
};

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
}));
